// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.assignment-modal {
  position: relative;
  width: 95%;
  max-width: 500px;
  max-height: 450px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.assignment-modal .assignment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}
.assignment-modal .assignment-modal-header h3 {
  margin: 0;
  color: #374151;
  font-size: 18px;
  font-weight: 600;
}
.assignment-modal .assignment-modal-header .assignment-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-header .assignment-modal-close:hover {
  background: #e5e7eb;
  color: #374151;
}
.assignment-modal .assignment-modal-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}
.assignment-modal .assignment-modal-content .assignment-modal-section {
  margin-bottom: 28px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section:last-child {
  margin-bottom: 0;
}
.assignment-modal .assignment-modal-content .assignment-modal-section h4 {
  margin: 0 0 12px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn:hover {
  background: #2563eb;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
  max-height: 300px;
  min-height: 150px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  cursor: pointer;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label:hover {
  background-color: #f9fafb;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label input[type=checkbox] {
  margin: 0;
  cursor: pointer;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label .user-name {
  font-size: 14px;
  color: #374151;
  flex: 1 1;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  min-height: 120px;
  max-height: 250px;
  overflow-y: auto;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid #f3f4f6;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item:last-child {
  border-bottom: none;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .user-number {
  font-weight: 500;
  color: #6b7280;
  min-width: 24px;
  font-size: 14px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .user-name {
  flex: 1 1;
  color: #374151;
  font-size: 14px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .assignment-delete-individual-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .assignment-delete-individual-btn:hover {
  background: #dc2626;
}
.assignment-modal .assignment-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  justify-content: flex-end;
}
.assignment-modal .assignment-modal-footer button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}
.assignment-modal .assignment-modal-footer button.assignment-save-btn {
  background: #10b981;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-save-btn:hover {
  background: #059669;
  transform: translateY(-1px);
}
.assignment-modal .assignment-modal-footer button.assignment-delete-all-btn {
  background: #ef4444;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-delete-all-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}
.assignment-modal .assignment-modal-footer button.assignment-cancel-btn {
  background: #6b7280;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-cancel-btn:hover {
  background: #4b5563;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .assignment-modal-overlay {
    padding: 10px;
  }
  .assignment-modal {
    width: 98%;
    min-width: 320px;
    max-height: 90vh;
  }
  .assignment-modal .assignment-modal-header {
    padding: 16px;
  }
  .assignment-modal .assignment-modal-header h3 {
    font-size: 16px;
  }
  .assignment-modal .assignment-modal-content {
    padding: 16px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section {
    margin-bottom: 20px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .section-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn {
    align-self: flex-start;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
    max-height: 150px;
  }
  .assignment-modal .assignment-modal-footer {
    padding: 16px;
    flex-direction: column;
  }
  .assignment-modal .assignment-modal-footer button {
    width: 100%;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .assignment-modal {
    width: 98%;
    min-width: 300px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
    max-height: 200px;
    min-height: 120px;
    padding: 12px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-checkbox-label {
    padding: 8px 6px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-checkbox-label .user-name {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AssignmentModal/AssignmentModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EAEA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AADJ;AAGI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADN;AAII;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAFN;AAIM;EACE,mBAAA;EACA,cAAA;AAFR;AAOE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AALJ;AAOI;EACE,mBAAA;AALN;AAOM;EACE,gBAAA;AALR;AAQM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANR;AASM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAPR;AASQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAPV;AASU;EACE,mBAAA;AAPZ;AAYM;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAVR;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAVV;AAYU;EACE,yBAAA;AAVZ;AAaU;EACE,SAAA;EACA,eAAA;AAXZ;AAcU;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAZZ;AAiBM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AAfV;AAiBU;EACE,mBAAA;AAfZ;AAkBU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhBZ;AAmBU;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAjBZ;AAoBU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AAlBZ;AAoBY;EACE,mBAAA;AAlBd;AA0BE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAxBN;AA0BM;EACE,mBAAA;EACA,YAAA;AAxBR;AA0BQ;EACE,mBAAA;EACA,2BAAA;AAxBV;AA4BM;EACE,mBAAA;EACA,YAAA;AA1BR;AA4BQ;EACE,mBAAA;EACA,2BAAA;AA1BV;AA8BM;EACE,mBAAA;EACA,YAAA;AA5BR;AA8BQ;EACE,mBAAA;EACA,2BAAA;AA5BV;;AAoCA;EACE;IACE,aAAA;EAjCF;EAoCA;IACE,UAAA;IACA,gBAAA;IACA,gBAAA;EAlCF;EAoCE;IACE,aAAA;EAlCJ;EAoCI;IACE,eAAA;EAlCN;EAsCE;IACE,aAAA;EApCJ;EAsCI;IACE,mBAAA;EApCN;EAsCM;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EApCR;EAsCQ;IACE,sBAAA;EApCV;EAwCM;IACE,iBAAA;EAtCR;EA2CE;IACE,aAAA;IACA,sBAAA;EAzCJ;EA2CI;IACE,WAAA;IACA,uBAAA;EAzCN;AACF;AA8CA;EACE;IACE,UAAA;IACA,gBAAA;EA5CF;EAgDM;IACE,iBAAA;IACA,iBAAA;IACA,aAAA;EA9CR;EAiDM;IACE,gBAAA;EA/CR;EAiDQ;IACE,eAAA;EA/CV;AACF","sourcesContent":[".assignment-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.assignment-modal {\n  position: relative;\n  width: 95%;\n  max-width: 500px;\n  //min-width: 500px;\n  max-height: 450px;\n  //min-height: 400px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  .assignment-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n\n    h3 {\n      margin: 0;\n      color: #374151;\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    .assignment-modal-close {\n      background: none;\n      border: none;\n      cursor: pointer;\n      color: #6b7280;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 4px;\n      border-radius: 4px;\n\n      &:hover {\n        background: #e5e7eb;\n        color: #374151;\n      }\n    }\n  }\n\n  .assignment-modal-content {\n    flex: 1;\n    padding: 24px;\n    overflow-y: auto;\n\n    .assignment-modal-section {\n      margin-bottom: 28px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      h4 {\n        margin: 0 0 12px 0;\n        color: #374151;\n        font-size: 14px;\n        font-weight: 600;\n      }\n\n      .section-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 12px;\n\n        .assignment-switch-mode-btn {\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          padding: 6px 12px;\n          background: #3b82f6;\n          color: white;\n          border: none;\n          border-radius: 4px;\n          font-size: 12px;\n          cursor: pointer;\n          transition: background-color 0.2s;\n\n          &:hover {\n            background: #2563eb;\n          }\n        }\n      }\n\n      .user-selection-container {\n        max-height: 300px;\n        min-height: 150px;\n        overflow-y: auto;\n        border: 1px solid #e5e7eb;\n        border-radius: 6px;\n        padding: 16px;\n\n        .user-checkbox-label {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          padding: 10px 8px;\n          cursor: pointer;\n          border-radius: 4px;\n\n          &:hover {\n            background-color: #f9fafb;\n          }\n\n          input[type=\"checkbox\"] {\n            margin: 0;\n            cursor: pointer;\n          }\n\n          .user-name {\n            font-size: 14px;\n            color: #374151;\n            flex: 1;\n          }\n        }\n      }\n\n      .current-assignments, .delete-assignments-container {\n        border: 1px solid #e5e7eb;\n        border-radius: 6px;\n        padding: 16px;\n        min-height: 120px;\n        max-height: 250px;\n        overflow-y: auto;\n\n        .assigned-user-item, .delete-user-item {\n          display: flex;\n          align-items: center;\n          padding: 10px 8px;\n          border-bottom: 1px solid #f3f4f6;\n          border-radius: 4px;\n\n          &:last-child {\n            border-bottom: none;\n          }\n\n          .user-number {\n            font-weight: 500;\n            color: #6b7280;\n            min-width: 24px;\n            font-size: 14px;\n          }\n\n          .user-name {\n            flex: 1;\n            color: #374151;\n            font-size: 14px;\n          }\n\n          .assignment-delete-individual-btn {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 24px;\n            height: 24px;\n            background: #ef4444;\n            color: white;\n            border: none;\n            border-radius: 4px;\n            cursor: pointer;\n            transition: background-color 0.2s;\n\n            &:hover {\n              background: #dc2626;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .assignment-modal-footer {\n    display: flex;\n    gap: 12px;\n    padding: 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    justify-content: flex-end;\n\n    button {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      padding: 8px 16px;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      transition: all 0.2s;\n\n      &.assignment-save-btn {\n        background: #10b981;\n        color: white;\n\n        &:hover {\n          background: #059669;\n          transform: translateY(-1px);\n        }\n      }\n\n      &.assignment-delete-all-btn {\n        background: #ef4444;\n        color: white;\n\n        &:hover {\n          background: #dc2626;\n          transform: translateY(-1px);\n        }\n      }\n\n      &.assignment-cancel-btn {\n        background: #6b7280;\n        color: white;\n\n        &:hover {\n          background: #4b5563;\n          transform: translateY(-1px);\n        }\n      }\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .assignment-modal-overlay {\n    padding: 10px;\n  }\n\n  .assignment-modal {\n    width: 98%;\n    min-width: 320px;\n    max-height: 90vh;\n\n    .assignment-modal-header {\n      padding: 16px;\n\n      h3 {\n        font-size: 16px;\n      }\n    }\n\n    .assignment-modal-content {\n      padding: 16px;\n\n      .assignment-modal-section {\n        margin-bottom: 20px;\n\n        .section-header {\n          flex-direction: column;\n          align-items: stretch;\n          gap: 8px;\n\n          .assignment-switch-mode-btn {\n            align-self: flex-start;\n          }\n        }\n\n        .user-selection-container {\n          max-height: 150px;\n        }\n      }\n    }\n\n    .assignment-modal-footer {\n      padding: 16px;\n      flex-direction: column;\n\n      button {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .assignment-modal {\n    width: 98%;\n    min-width: 300px;\n\n    .assignment-modal-content {\n      .assignment-modal-section {\n        .user-selection-container {\n          max-height: 200px;\n          min-height: 120px;\n          padding: 12px;\n        }\n\n        .user-checkbox-label {\n          padding: 8px 6px;\n\n          .user-name {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
